// src/theme.js
export const lightTheme = {
    title: 'light', // theme identifier
    body: '#FFFFFF', // Light background for the body
    text: '#363537', // Darker text for readability on light background
    toggleBorder: '#FFF', // Lighter toggle border
    gradient: 'linear-gradient(#39598A, #79D7ED)', // Lighter gradient
    primary: '#6D5DFC', // A light primary color
    secondary: '#111769', // Lighter secondary color
    accent: '#FF69B4', // A light accent color
    background: '#E2E2E2', // Lighter background for elements
    hover: '#ADD8E6', // Lighter hover state
    borderColor: '#DDD', // Light border color
    header: '#FFFFFF', // Light header background
    sidebar: '#F8F8F8', // Light sidebar background
    modalBackground: 'rgba(255, 255, 255, 0.8)', // Light modal background
    card: '#F0F0F0', // Light card background
};
  
export const darkTheme = {
    title: 'dark', // theme identifier
    body: '#0A192F',
    text: '#CCD6F6',
    toggleBorder: '#6B8096',
    gradient: 'linear-gradient(#091236, #1E215D)',
    primary: '#57c2ec',
    secondary: '#8892B0',
    accent: '#c4e5f2',
    background: '#112240',
    hover: '#95daf5',
    borderColor: '#57c2ec',
    header: '#0A192F',
    sidebar: '#020c1b',
    modalBackground: 'rgba(0, 0, 0, 0.6)',
    card: '#112240',
  };
 